///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";
import { every } from "lodash";

import shipperViewColumns from "../../../helpers/shipperViewColumns";
import { analyticsView } from "../../../helpers/types";
import {
  filterLoads,
  setColumnWidth,
  sortLoads,
  toggleColumnFilterMenu,
  setLoadView
} from "../../../slices/analyticsSlice";
import LanesGridBody from "../pricing/LanesGridBody";
import PricingGridHeader from "../pricing/PricingGridHeader";

export const ShipperViewGrid = ({ division }) => {
  const {
    analytics: {
      selectedRowIndex,
      selectedButtonIndex,
      shipperView: {
        lanes: groupedByShipper,
        columnFilterMenu,
        columnFilters,
        rangeFilters,
        columnWidths,
        sortField,
        sortOrder
      }
    },
    bidSummary: { summary }
  } = useSelector(state => state);

  const areAllLoadsExcluded = every(
    groupedByShipper?.filter(x => x.metaData.matched === true),
    { exclude: "Include" }
  );

  return (
    <div data-testid="shipper-view-grid" className="analytics-table-width">
      <div
        style={{ maxHeight: window.screen.height - 240 }}
        className="overflow-x--scroll scroll"
        id="analytics-grid-shipperView"
      >
        <table className="bg-white pl-16 pos-relative">
          <PricingGridHeader
            columns={shipperViewColumns}
            columnOrder={shipperViewColumns.map(m => m.field)}
            sortField={sortField}
            sortOrder={sortOrder}
            columnFilterMenu={columnFilterMenu}
            columnFilters={columnFilters}
            rangeFilters={rangeFilters}
            columnWidths={columnWidths}
            analyticsGridView={analyticsView.shipperView}
            setColumnWidth={setColumnWidth}
            toggleColumnFilterMenu={toggleColumnFilterMenu}
            filterPricingLanes={filterLoads}
            sortPricingLanes={sortLoads}
            bidDivision={division ?? summary?.division}
            buttonLabelValue={areAllLoadsExcluded}
          />
          {groupedByShipper && (
            <LanesGridBody
              columns={shipperViewColumns}
              lanes={groupedByShipper}
              offset={0}
              perPage={groupedByShipper.length}
              columnOrder={shipperViewColumns.map(m => m.field)}
              bidDivision={division ?? summary?.division}
              analyticsGridView={analyticsView.shipperView}
              onRowClick={setLoadView}
              selectedRowIndex={selectedRowIndex}
              selectedButtonIndex={selectedButtonIndex}
            />
          )}
        </table>
      </div>
    </div>
  );
};

export default ShipperViewGrid;
